import { render, staticRenderFns } from "./StudentCoursesPage.vue?vue&type=template&id=3690d2de&scoped=true"
import script from "./StudentCoursesPage.vue?vue&type=script&lang=js"
export * from "./StudentCoursesPage.vue?vue&type=script&lang=js"
import style0 from "./StudentCoursesPage.vue?vue&type=style&index=0&id=3690d2de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690d2de",
  null
  
)

export default component.exports